import React, {FC} from 'react'
import {CellPropsType} from './cellPropsType'

const DatabaseVersion: FC<CellPropsType> = ({cell}) => {
  const value = cell.getValue()

  return <>{value}</>
}

export default DatabaseVersion
